/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as Functions from '../../utils/Functions';

import Locations from '../location/Locations';
import Customizations from '../customization/Customizations';
import Options from '../option/Options';
import Products from '../product/Products';
import Categories from '../category/Categories';
import ProductImages from '../product/ProductImages';
import ProductItems from '../product/ProductItems';
import Users from '../user/Users';
import Zones from '../location/Zones';
import Orders from '../order/Orders';
import OrderItems from '../order/OrderItems';
import Tax from '../tax/Tax';
import Taxes from '../tax/Taxes';
import Company from '../company/Companies';
import Home from '../Home/Home';
import Menu from '../menu/Menu';
import Items from '../item/Items';
import Tiers from '../tier/Tiers';
import Coupons from '../coupon/Coupons';
import Restrictions from '../coupon/Restrictions';
import Reports from '../report/Reports';
import VersionAndBuildNumber from '../share/VersionAndBuildNumber';
import { versionNumberStyles } from '../../css/style';
import {
  checkIsAuthorized,
  getLocationIdOfAuthorizationOrAdmin,
  getPermittedActionName,
  checkIsLocationAdmin,
} from '../../utils/AuthorizationChecks';

const versionStyles = versionNumberStyles();

class ListResources extends Component {
  renderPage = (isLocationAdmin) => {
    const {
      loading,
      resources,
      actions,
      apiToken,
      viewMoreLoading,
      match,
      filter,
      admin,
      selectedItems,
    } = this.props;
    const { resource, subResource } = match.params;

    const isLocked = getPermittedActionName(admin, resource) === 'lock';
    // When something is locked, we want to let restaurants preview it even if they can't use it, to entice them
    const canAccountSeePage = checkIsAuthorized(admin, resource, subResource, 'view') || isLocked;

    if (!canAccountSeePage) {
      return (
        <Redirect
          to={{
            pathname: '/unauthorized',
            state: { from: { resource, subResource } },
          }}
        />
      );
    }
    // TODO: <ResourceList resource={resource} items={}
    const paginationOptions = (resources.pagination && resources.pagination.options) ? resources.pagination.options : null;
    switch (resource) {
      case 'locations':
        let locations = [];
        if (isLocationAdmin && Array.isArray(resources.locations)) {
          const adminLocationId = getLocationIdOfAuthorizationOrAdmin('locations', admin);
          locations = resources.locations.filter(location => location.id === adminLocationId);
        } else {
          locations = resources.locations;
        }
        if (subResource === 'zones') {
          return <Zones loading={loading} locations={locations} actions={actions} apiToken={apiToken} />;
        }
        if (subResource === 'catering-zones') {
          return <Zones loading={loading} locations={locations} actions={actions} apiToken={apiToken} />;
        }
        return (
          <Locations
            loading={loading}
            locations={locations}
            actions={actions}
            apiToken={apiToken}
            viewMoreLoading={viewMoreLoading}
            pagination={resources.pagination && resources.pagination.locations ? resources.pagination.locations : null}
            admin={admin}
          />
        );

      case 'customizations':
        if (subResource === 'options') {
          const findOptionsArgs = { match, resources };
          const options = resources && resources.customizations
            ? Functions.findEntityByID(findOptionsArgs).options
            : null;

          return (
            <Options
              admin={admin}
              loading={loading}
              customizations={resources.customizations}
              locations={resources.locations}
              options={options}
              actions={actions}
              pagination={paginationOptions}
              viewMoreLoading={viewMoreLoading}
              apiToken={apiToken}
            />
          );
        }
        return <Customizations loading={loading} customizations={resources.customizations} actions={actions} apiToken={apiToken} />;

      case 'products':
        if (subResource === 'images') {
          return <ProductImages loading={loading} products={resources.products} actions={actions} apiToken={apiToken} />;
        } if (subResource === 'items') {
          return <ProductItems loading={loading} products={resources.products} actions={actions} apiToken={apiToken} />;
        }
        return <Products loading={loading} products={resources.products} actions={actions} apiToken={apiToken} />;

      case 'categories':
        return (
          <Categories
            loading={loading}
            categories={resources.categories}
            actions={actions}
            apiToken={apiToken}
            selectedItems={selectedItems}
          />
        );

      case 'options':
        return (
          <Options
            admin={admin}
            actions={actions}
            apiToken={apiToken}
            loading={loading}
            customizations={resources.customizations}
            locations={resources.locations}
            options={resources.options}
            pagination={paginationOptions}
            viewMoreLoading={viewMoreLoading}
          />
        );

      case 'users':
        if (subResource === 'addresses') {
          return <Home resources={resources} loading={loading} actions={actions} apiToken={apiToken} filter={filter} />;
        }
        return (
          <Users
            loading={loading}
            viewMoreLoading={viewMoreLoading}
            users={resources.users}
            actions={actions}
            apiToken={apiToken}
            locations={resources.locations}
            loyaltyReport={resources['users/loyaltyReport']}
            pagination={resources.pagination && resources.pagination.users ? resources.pagination.users : null}
            totalSize={resources.pagination && resources.pagination.users ? resources.pagination.users.totalSize : 0}
          />
        );

      case 'orders':
        if (subResource === 'items') {
          return <OrderItems loading={loading} orders={resources.orders} actions={actions} apiToken={apiToken} />;
        }
        return (
          <Orders
            loading={loading}
            viewMoreLoading={viewMoreLoading}
            orders={resources.orders}
            locations={resources.locations}
            actions={actions}
            apiToken={apiToken}
            pagination={resources.pagination && resources.pagination.orders ? resources.pagination.orders : null}
          />
        );

      case 'taxes':
        return (
          <Taxes
            loading={loading}
            taxes={resources.taxes}
            actions={actions}
            apiToken={apiToken}
            locations={resources.locations}
          />
        );
      case 'companies':
        return <Company loading={loading} companies={resources.companies} actions={actions} apiToken={apiToken} />;

      case 'menu':
        return (
          <Menu
            loading={loading}
            customizations={resources.customizations}
            options={resources.options}
            filteredProducts={resources.filteredProducts}
            categories={resources.categories}
            taxes={resources.taxes}
            locations={resources.locations}
            actions={actions}
            apiToken={apiToken}
            viewMoreLoading={viewMoreLoading}
            pagination={resources.pagination && resources.pagination.products ? resources.pagination.products : null}
            admin={admin}
          />
        );
      case 'items':
        return (
          <Items
            loading={loading}
            products={resources.products}
            actions={actions}
            apiToken={apiToken}
            categories={resources.categories}
            locations={resources.locations}
            selectedItems={selectedItems}
            admin={admin}
          />
        );
      case 'tiers':
        return <Tiers actions={actions} apiToken={apiToken} />;
      case 'coupons':
        if (subResource === 'restrictions') {
          return <Restrictions loading={loading} coupons={resources.coupons} actions={actions} apiToken={apiToken} />;
        }
        return <Coupons actions={actions} apiToken={apiToken} />;
      case 'reports':
        return <Reports loading={loading} actions={actions} apiToken={apiToken} />;
      default:
        return <Home resources={resources} loading={loading} actions={actions} apiToken={apiToken} filter={filter} />;
    }
  }

  render() {
    const {
      match, admin,
    } = this.props;
    const { resource, subResource } = match.params;
    const isLocationAdmin = !!(admin && checkIsLocationAdmin(admin));

    return (
      <div style={versionStyles.pageContainerWithVersionNumberBelow}>
        {this.renderPage(isLocationAdmin)}
        <VersionAndBuildNumber />
      </div>
    );
  }
}

ListResources.propTypes = {
  resources: PropTypes.objectOf(PropTypes.any).isRequired,
  loading: PropTypes.bool,
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  viewMoreLoading: PropTypes.number,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  admin: PropTypes.object,
  filter: PropTypes.object,
  selectedItems: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
};

ListResources.defaultProps = {
  loading: null,
  viewMoreLoading: 0,
  filter: null,
  admin: null,
};

export default withRouter(ListResources);
